var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriangleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 108,
    viewBox: "0 0 106 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53564 48.3499C-0.229004 46.6889 0.00798671 42.6069 2.94627 41.2771L93.336 0.365944C95.8844 -0.787463 98.7993 0.964046 98.9773 3.75562L105.288 102.764C105.493 105.983 102.001 108.108 99.2364 106.448L2.53564 48.3499Z",
    fill: "#FFA463"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleYellow);
export default __webpack_public_path__ + "static/media/TriangleYellow.6c24426fec9a1290441ae5fc821e1a02.svg";
export { ForwardRef as ReactComponent };